import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import { Button, Link as MUILink } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import { useStoreState } from 'easy-peasy'
import { Link } from 'wouter'

import { BACK_CLICK } from 'artkive/constants/tracker/mainNavigation'
import { exportUtmParameters } from 'artkive/utils/tracker'

import { withClickTracker } from '../Tracker'

const useBackStyles = makeStyles((muiTheme) => ({
  root: {
    boxShadow: 'unset',
    fontWeight: 600,
    fontSize: 16,

    '&:hover': {
      backgroundColor: 'unset',
      color: muiTheme.palette.primary.main,
    },
  },
  startIcon: {
    marginRight: 0,
  },
}))

const TrackedButton = withClickTracker(Button)

const WrappedLink = forwardRef((props, _ref) => <Link {...props} />)

const WrappedMUILink = forwardRef((props, _ref) => <MUILink {...props} />)

const isInternalLink = (href) => href.startsWith('~/')

const buildBackLinkHref = ({ href, tracking, promoCode }) => {
  if (isInternalLink(href) || !href.startsWith('http')) return href

  try {
    const urlObj = new URL(href, window.location.origin)
    const params = urlObj.searchParams
    Object.entries({ ...exportUtmParameters(tracking), param_1: promoCode }).forEach(([key, value]) => {
      if (!value || params.get(key)) return

      params.set(key, value)
    })
    return urlObj.toString()
  } catch (error) {
    return href
  }
}

const BackButton = ({ icon = false, href, ...rest }) => {
  const classes = useBackStyles()
  const tracking = useStoreState(({ promoStore }) => promoStore.tracking)
  const promoCode = useStoreState(({ promoStore }) => promoStore.promoCode)
  const component = isInternalLink(href) ? WrappedLink : WrappedMUILink
  const backHref = buildBackLinkHref({ href, tracking, promoCode })

  return (
    <TrackedButton
      variant='text'
      size='large'
      role='link'
      classes={{
        root: classes.root,
        startIcon: classes.startIcon,
      }}
      trackerEvent={BACK_CLICK}
      component={component}
      href={backHref}
      {...rest}
      startIcon={<ArrowBackIosIcon color={icon ? 'action' : 'inherit'} />}
      disableRipple
    >
      <span>{!icon && 'Back'}</span>
    </TrackedButton>
  )
}

BackButton.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.bool,
}

export default BackButton
